import { MemberFilter } from '../types';
import { Checkbox } from '../../../components/ui/Checkbox';
import Input from '../../../components/ui/Input';
import { useState } from 'react';

interface MemberFilterPanelProps {
  members: MemberFilter[];
  onMemberToggle: (memberId: string) => void;
  onSelectAll: () => void;
  onDeselectAll: () => void;
}

const MemberFilterPanel = ({ members, onMemberToggle, onSelectAll, onDeselectAll }: MemberFilterPanelProps) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredMembers = members.filter(member =>
    member.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const selectedCount = members.filter(m => m.selected).length;

  return (
    <div className="bg-card rounded-md border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Filter by Members</h3>
        <span className="text-sm text-muted-foreground">
          {selectedCount} of {members.length} selected
        </span>
      </div>

      <Input
        type="search"
        placeholder="Search members..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="mb-4"
      />

      <div className="flex gap-2 mb-4">
        <button
          onClick={onSelectAll}
          className="text-sm text-primary hover:text-primary/80 transition-interactive font-medium"
        >
          Select All
        </button>
        <span className="text-muted-foreground">|</span>
        <button
          onClick={onDeselectAll}
          className="text-sm text-primary hover:text-primary/80 transition-interactive font-medium"
        >
          Deselect All
        </button>
      </div>

      <div className="max-h-64 overflow-y-auto space-y-2">
        {filteredMembers.map((member) => (
          <Checkbox
            key={member.id}
            label={member.name}
            checked={member.selected}
            onChange={() => onMemberToggle(member.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default MemberFilterPanel;